import { render } from "./UpMoment.vue?vue&type=template&id=3f10a44a"
import script from "./UpMoment.vue?vue&type=script&lang=js"
export * from "./UpMoment.vue?vue&type=script&lang=js"

import "./UpMoment.vue?vue&type=style&index=0&id=3f10a44a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__